import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import EditIcon from 'transfix-icons/build/EditIcon'
import { Card } from 'transfix-ui/components/Card'
import { IconButton } from 'transfix-ui/components/IconButton'
import { InlineMessage, INLINE_MESSAGE_VARIANTS } from 'transfix-ui/components/InlineMessage'
import { Spinner } from 'transfix-ui/components/Spinner'
import { Typography } from 'transfix-ui/core'
import { ICarrierAccountingState } from 'types/carrier'
import {
  openCarrierAccountingModal,
  fetchCarrierAccounting,
} from 'apps/carrier/utils/actions/carrierAccounting'
import { IStore } from 'apps/carrier/utils/reducers'
import { DISPLAY } from 'constants/display'
import { AccountingModal } from './AccountingModal'
import { FactoringAddress } from './FactoringAddress'
import { CarrierBillingAddress } from './carrierBillingAddress'

export interface ISelector extends ICarrierAccountingState {
  carrierId?: string
}

export const Accounting = () => {
  const dispatch = useDispatch()
  const { accounting, carrierId, error, fetching } = useSelector<IStore, ISelector>(store => ({
    ...store.accounting,
    carrierId: store.carrier.carrierDetails?.id,
  }))

  useEffect(() => {
    if (carrierId) {
      dispatch(fetchCarrierAccounting(carrierId))
    }
  }, [carrierId])

  const { carrierBillingLocation, factor, paymentMethod, quickPayEnrollment } = accounting || {}

  const quickPayEnrollmentText = quickPayEnrollment ? 'Yes' : 'No'
  const editAccounting = () => dispatch(openCarrierAccountingModal())
  return (
    <Card>
      <div className='row no-gutter pv4 ml0'>
        <Typography variant='h3' className='fl mb0 mt2'>
          Accounting
        </Typography>
        {accounting && (
          <div className='fr'>
            <IconButton
              Icon={EditIcon}
              color='tertiary'
              onClick={editAccounting}
              data-test='edit-accounting'
              label='Edit Accounting'
              size='large'
            />
          </div>
        )}
      </div>
      {fetching && <Spinner position='relative' />}
      {error && <InlineMessage message={error} type={INLINE_MESSAGE_VARIANTS.ALERT} />}
      {accounting && (
        <>
          <div className='row no-gutter  ml0'>
            <div className='col-xs-5'>
              <small>Receivables Factored?</small>
              <p>{factor ? 'Yes' : 'No'}</p>
            </div>
            <div className='col-xs-7'>
              <small>Factoring Company</small>
              <p>{factor ? factor.name : DISPLAY.empty}</p>
            </div>
          </div>
          <div className='row no-gutter  ml0'>
            <div className='col-xs-5'>
              <div className='row no-gutter'>
                <div className='col-xs-12'>
                  <small>Payment Method</small>
                  <p>{paymentMethod || DISPLAY.empty}</p>
                </div>
                <div className='col-xs-12'>
                  <small>QuickPay Enrollment</small>
                  <p>{quickPayEnrollment !== undefined ? quickPayEnrollmentText : DISPLAY.empty}</p>
                </div>
              </div>
            </div>
            <div className='col-xs-7'>
              <FactoringAddress factor={factor} />
            </div>
            <div className='col-xs-7 mt1'>
              <CarrierBillingAddress carrierBillingLocation={carrierBillingLocation} />
            </div>
          </div>
        </>
      )}
      <AccountingModal />
    </Card>
  )
}
